import { createTheme } from '@mantine/core';
import type { MantineTheme } from '@mantine/core';

export const glassTheme = createTheme({
    primaryColor: 'cyan',
    defaultRadius: 'md',
    fontFamily: '"Inter", sans-serif',
    fontFamilyMonospace: '"JetBrains Mono", monospace',

    colors: {
        // Custom "Neon Blue" palette replacing default cyan
        cyan: [
            '#e0fcff',
            '#bef4fc',
            '#87eaf8',
            '#48dff5',
            '#00d6f5', // Primary
            '#00bfdb',
            '#0095ab',
            '#006b7d',
            '#004250',
            '#001a24',
        ],
        // Deep Navy/Black palette for backgrounds
        dark: [
            '#C1C2C5',
            '#A6A7AB',
            '#909296',
            '#5c5f66',
            '#373A40',
            '#2C2E33',
            '#25262b',
            '#1A1B1E', // Standard Dark
            '#141517', // Darker
            '#050507', // Almost Black (Base)
        ],
    },

    components: {
        Card: {
            defaultProps: {
                radius: 'md',
            },
            styles: () => ({
                root: {
                    backgroundColor: 'rgba(10, 15, 30, 0.4)', // Semi-transparent navy
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(0, 240, 255, 0.1)', // Subtle neon border
                    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.5)',
                },
            }),
        },
        Input: {
            styles: (theme: MantineTheme) => ({
                input: {
                    backgroundColor: 'rgba(5, 5, 10, 0.6)',
                    borderColor: 'rgba(0, 240, 255, 0.2)',
                    color: theme.colors.cyan[1], // Light Cyan text
                    backdropFilter: 'blur(4px)',
                    '&:focus': {
                        borderColor: theme.colors.cyan[4],
                        boxShadow: `0 0 10px rgba(0, 214, 245, 0.3)`,
                    },
                },
            }),
        },
        Button: {
            defaultProps: {
                variant: 'filled',
            },
            styles: () => ({
                root: {
                    backgroundImage: 'linear-gradient(45deg, #00d6f5 0%, #0095ab 100%)',
                    color: '#000',
                    fontWeight: 600,
                    border: 0,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: '0 0 20px rgba(0, 214, 245, 0.4)',
                    }
                }
            })
        },
        Title: {
            styles: (theme: MantineTheme) => ({
                root: {
                    color: theme.colors.cyan[0],
                    letterSpacing: '0.05em',
                }
            })
        }
    },
});
